//* Libraries imports
import { Suspense } from "react";

//* Components imports
import { Content } from "./_componentes/index";

export default function ProcessEditalView() {
  return (
    <div className="row">
      <Suspense>
        <Content />
      </Suspense>
    </div>
  );
}
